const chapter = {
  id: 'evolution',
  slug: 'evolution',
  subject: 'biology',
  subjectLabel: 'Biology',
  exam: 'NEET',
  title: {
    english: 'Evolution',
        hindi: 'क्रम-विकास',
  },
  estReadMinutes: 55,
  difficulty: {
    english: 'Medium',
        hindi: 'मध्यम',
  },
  weightage: {
    english: '2-3 questions in NEET',
        hindi: 'NEET में 2-3 प्रश्न',
  },
  syllabusTags: ['Evolution', 'NEET', 'Class-12'],
  sections: [
    {
      id: 'origin',
      title: {
        english: 'Origin of Life & Universe',
        hindi: 'जीवन और ब्रह्माण्ड की उत्पत्ति',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Big Bang theory** — universe originated ~**13.7 billion years ago** from singular explosion. Galaxies, stars formed; Earth ~4.5 bya.',
        hindi: '**बिग बैंग सिद्धांत** - ब्रह्मांड की उत्पत्ति ~**13.7 अरब वर्ष पहले** एक ही विस्फोट से हुई थी। आकाशगंगाएँ, तारे बने; पृथ्वी ~4.5 बाय।',
            },
            {
              english: '**Theories of origin of life**:',
        hindi: '**जीवन की उत्पत्ति के सिद्धांत**:',
            },
            {
              english: '• **Theory of special creation** — by supernatural power (non-scientific).',
        hindi: '• **विशेष सृजन का सिद्धांत** — अलौकिक शक्ति द्वारा (गैर-वैज्ञानिक)।',
            },
            {
              english: '• **Spontaneous generation (abiogenesis)** — life from non-living; disproved by **Louis Pasteur** with swan-necked flask experiments.',
        hindi: '• **स्वतःस्फूर्त पीढ़ी (अबियोजेनेसिस)** - निर्जीव से जीवन; **लुई पाश्चर** ने हंस-गर्दन वाले फ्लास्क प्रयोगों से इसे अस्वीकृत कर दिया।',
            },
            {
              english: '• **Panspermia** — life came from outer space (spores).',
        hindi: '• **पैनस्पर्मिया** - जीवन बाहरी अंतरिक्ष (बीजाणु) से आया है।',
            },
            {
              english: '• **Oparin (Russia) & Haldane (England)** — chemical evolution: first life from pre-existing simple inorganic and organic molecules; primitive atmosphere had **CH₄, NH₃, H₂, water vapour**, no free O₂ (reducing).',
        hindi: '• **ओपेरिन (रूस) और हाल्डेन (इंग्लैंड)** — रासायनिक विकास: पहले से मौजूद सरल अकार्बनिक और कार्बनिक अणुओं से पहला जीवन; आदिम वातावरण में **CH₄, NH₃, H₂, जलवाष्प** था, कोई मुक्त O₂ (घटाने वाला) नहीं था।',
            },
            {
              english: '**Miller-Urey experiment (1953)** — recreated primitive atmosphere in flask (CH₄, NH₃, H₂, water vapour) + electric discharge (700°C) for one week → formed amino acids. Supported chemical origin.',
        hindi: '**मिलर-उरे प्रयोग (1953)** - एक सप्ताह के लिए फ्लास्क (सीएच₄, एनएच₃, एच₂, जल वाष्प) + इलेक्ट्रिक डिस्चार्ज (700 डिग्री सेल्सियस) में आदिम वातावरण को फिर से बनाया → अमीनो एसिड का गठन किया। समर्थित रासायनिक उत्पत्ति.',
            },
          ],
        },
      ],
    },
    {
      id: 'evidences',
      title: {
        english: 'Evidences of Evolution',
        hindi: 'विकास के प्रमाण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Palaeontology (fossils)** — preserved remains in sedimentary rocks; dated by radioactive decay (C-14, K-Ar). E.g. *Archaeopteryx* — connecting link between reptiles & birds.',
        hindi: '**पुरापाषाण विज्ञान (जीवाश्म)** - तलछटी चट्टानों में संरक्षित अवशेष; रेडियोधर्मी क्षय (सी-14, के-एआर) द्वारा दिनांकित। जैसे *आर्कियोप्टेरिक्स* - सरीसृपों और पक्षियों के बीच जोड़ने वाली कड़ी।',
            },
            {
              english: '**Comparative anatomy & morphology**:',
        hindi: '**तुलनात्मक शरीर रचना और आकृति विज्ञान**:',
            },
            {
              english: '• **Homologous organs** — same origin & structure, different function. **Divergent evolution**. Forelimbs of whale, bat, cheetah, human.',
        hindi: '• **समजात अंग** - समान उत्पत्ति और संरचना, अलग-अलग कार्य। **विभिन्न विकास**। व्हेल, चमगादड़, चीता, मानव के अग्रपाद।',
            },
            {
              english: '• **Analogous organs** — different origin, similar function. **Convergent evolution**. Wings of butterfly & bird; eye of octopus & mammals.',
        hindi: '• **समान अंग** - भिन्न उत्पत्ति, समान कार्य। **अभिसरण विकास**। तितली और पक्षी के पंख; ऑक्टोपस और स्तनधारियों की आँख.',
            },
            {
              english: '• **Vestigial organs** — reduced, non-functional remnants. Vermiform appendix, ear muscles, nictitating membrane in humans (~90 vestigial organs).',
        hindi: '• **अवशिष्ट अंग** - कम, गैर-कार्यात्मक अवशेष। मनुष्यों में वर्मीफॉर्म अपेंडिक्स, कान की मांसपेशियां, निक्टिटेटिंग झिल्ली (~90 अवशेषी अंग)।',
            },
            {
              english: '**Embryology** — von Baer; embryos of vertebrates show similarity. Ernst Haeckel\'s "Ontogeny recapitulates phylogeny" (now disproved but principle of similarity holds).',
        hindi: '**भ्रूणविज्ञान** - वॉन बेयर; कशेरुकियों के भ्रूण समानता दर्शाते हैं। अर्न्स्ट हेकेल की "ओन्टोजेनी रीकैपिटुलेट्स फाइलोजेनी" (अब अस्वीकृत हो गई है लेकिन समानता का सिद्धांत कायम है)।',
            },
            {
              english: '**Biogeography** — Darwin\'s finches in Galápagos; Australian marsupials.',
        hindi: '**बायोग्राफी** - गैलापागोस में डार्विन के फिंच; ऑस्ट्रेलियाई मार्सुपियल्स।',
            },
            {
              english: '**Molecular evidence** — DNA, protein sequence similarity (cytochrome c, haemoglobin) → degree of relatedness.',
        hindi: '**आण्विक साक्ष्य** - डीएनए, प्रोटीन अनुक्रम समानता (साइटोक्रोम सी, हीमोग्लोबिन) → संबंधितता की डिग्री।',
            },
          ],
        },
      ],
    },
    {
      id: 'theories',
      title: {
        english: 'Theories of Evolution',
        hindi: 'विकास के सिद्धान्त',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Lamarckism (1809)** — *Philosophie Zoologique*. **Use & disuse of organs** + **inheritance of acquired characters**. Long neck of giraffe due to stretching; passed on. Disproved by **August Weismann** (cut tails of mice over 22 generations — offspring still had tails).',
        hindi: '**लैमार्किज्म (1809)** — *फिलोसोफी जूलॉजी*। **अंगों का उपयोग और दुरुपयोग** + **अर्जित लक्षणों की विरासत**। खिंचाव के कारण जिराफ की लंबी गर्दन; आगे बधाया। **अगस्त वीज़मैन** द्वारा अस्वीकृत (22 पीढ़ियों से अधिक चूहों की पूंछ काटी गई - संतानों में अभी भी पूंछ थी)।',
            },
            {
              english: '**Darwinism (1859)** — *On the Origin of Species*; voyage on **HMS Beagle**, Galápagos finches.',
        hindi: '**डार्विनवाद (1859)** — *प्रजातियों की उत्पत्ति पर*; **एचएमएस बीगल**, गैलापागोस फिंच पर यात्रा।',
            },
            {
              english: '• Key ideas: variation in populations, struggle for existence, **natural selection** ("survival of the fittest"), descent with modification.',
        hindi: '• मुख्य विचार: जनसंख्या में भिन्नता, अस्तित्व के लिए संघर्ष, **प्राकृतिक चयन** ("योग्यतम की उत्तरजीविता"), संशोधन के साथ वंश।',
            },
            {
              english: '• Wallace independently arrived at same conclusion.',
        hindi: '• वालेस स्वतंत्र रूप से उसी निष्कर्ष पर पहुंचे।',
            },
            {
              english: '**Neo-Darwinism (Modern Synthesis)** — combines Darwinian natural selection + Mendelian genetics + population genetics. Variation arises from mutation & recombination; natural selection acts on phenotype.',
        hindi: '**नव-डार्विनवाद (आधुनिक संश्लेषण)** - डार्विनियन प्राकृतिक चयन + मेंडेलियन आनुवंशिकी + जनसंख्या आनुवंशिकी को जोड़ती है। उत्परिवर्तन और पुनर्संयोजन से भिन्नता उत्पन्न होती है; प्राकृतिक चयन फेनोटाइप पर कार्य करता है।',
            },
            {
              english: '**Hugo de Vries (1901)** — **Mutation theory** based on *Oenothera lamarckiana*. Sudden, large, heritable changes drive evolution (saltation).',
        hindi: '**ह्यूगो डी व्रीस (1901)** - **उत्परिवर्तन सिद्धांत** *ओएनोथेरा लैमार्कियाना* पर आधारित। अचानक, बड़े, वंशानुगत परिवर्तन विकास (नमकीनीकरण) को प्रेरित करते हैं।',
            },
          ],
        },
      ],
    },
    {
      id: 'hardy-weinberg',
      title: {
        english: 'Hardy-Weinberg Principle',
        hindi: 'हार्डी-वाइनबर्ग सिद्धान्त',
      },
      blocks: [
        {
          type: 'paragraph',
          text: {
            english: 'Allele and genotype frequencies remain constant in a population from generation to generation in the absence of evolutionary forces (genetic equilibrium).',
        hindi: 'विकासवादी ताकतों (आनुवंशिक संतुलन) की अनुपस्थिति में एलील और जीनोटाइप आवृत्तियां पीढ़ी-दर-पीढ़ी आबादी में स्थिर रहती हैं।',
          },
        },
        {
          type: 'equation',
          latex: 'p^2 + 2pq + q^2 = 1, \\quad p + q = 1',
          label: {
            english: 'For two alleles A (p) and a (q)',
        hindi: 'दो एलील्स ए (पी) और ए (क्यू) के लिए',
          },
        },
        {
          type: 'list',
          items: [
            {
              english: 'p² = freq of AA, q² = freq of aa, 2pq = freq of Aa.',
        hindi: 'p² = AA की आवृत्ति, q² = AA की आवृत्ति, 2pq = आ की आवृत्ति। **स्थितियां** (कोई विकास नहीं): कोई उत्परिवर्तन नहीं, कोई प्रवासन नहीं, बड़ी आबादी (कोई आनुवंशिक बहाव नहीं), यादृच्छिक संभोग, कोई प्राकृतिक चयन नहीं।',
            },
            {
              english: '**Conditions** (no evolution): no mutation, no migration, large population (no genetic drift), random mating, no natural selection.',
        hindi: '**शर्तें** (कोई विकास नहीं): कोई उत्परिवर्तन नहीं, कोई प्रवासन नहीं, बड़ी आबादी (कोई आनुवंशिक बहाव नहीं), यादृच्छिक संभोग, कोई प्राकृतिक चयन नहीं।',
            },
            {
              english: 'Disturbance of any condition → **change in allele frequency = evolution**.',
        hindi: 'किसी भी स्थिति में गड़बड़ी → **एलील में परिवर्तन frequency = evolution**। **विकास की पाँच शक्तियाँ**:',
            },
            {
              english: '**Five forces of evolution**:',
        hindi: '**विकास की पाँच शक्तियाँ**:',
            },
            {
              english: '• Mutation — sudden heritable change; raw material.',
        hindi: '• उत्परिवर्तन - अचानक वंशानुगत परिवर्तन; कच्चा माल.',
            },
            {
              english: '• Genetic drift — random change; significant in small populations. **Founder effect**, **Bottleneck effect**.',
        hindi: '• आनुवंशिक बहाव - यादृच्छिक परिवर्तन; छोटी आबादी में महत्वपूर्ण. **संस्थापक प्रभाव**, **बॉटलनेक प्रभाव**।',
            },
            {
              english: '• Gene flow / Migration — exchange of alleles between populations.',
        hindi: '• जीन प्रवाह / प्रवासन - आबादी के बीच एलील्स का आदान-प्रदान।',
            },
            {
              english: '• Genetic recombination — meiotic shuffling.',
        hindi: '• आनुवंशिक पुनर्संयोजन - अर्धसूत्रीविभाजन।',
            },
            {
              english: '• **Natural selection** — directional, stabilising, or disruptive.',
        hindi: '• **प्राकृतिक चयन** - दिशात्मक, स्थिरीकरण, या विघटनकारी।',
            },
          ],
        },
      ],
    },
    {
      id: 'human-evolution',
      title: {
        english: 'Human Evolution',
        hindi: 'मानव विकास',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Dryopithecus** (~15 mya) — common ancestor of apes and humans; ape-like.',
        hindi: '**ड्रायोपिथेकस** (~15 माइआ) - वानरों और मनुष्यों का सामान्य पूर्वज; वानर जैसा।',
            },
            {
              english: '**Ramapithecus** (~15 mya) — more man-like; small canines, walked upright partially.',
        hindi: '**रामापिथेकस** (~15 माइआ) - अधिक मनुष्य जैसा; छोटे कुत्ते, आंशिक रूप से सीधे चलते थे।',
            },
            {
              english: '**Australopithecus** (~3-4 mya) — Africa; bipedal; brain ~500 cc; used stones; "Lucy" specimen.',
        hindi: '**आस्ट्रेलोपिथेकस** (~3-4 माइया) - अफ़्रीका; द्विपाद; मस्तिष्क ~500 सीसी; प्रयुक्त पत्थर; "लुसी" नमूना.',
            },
            {
              english: '**Homo habilis** (~2 mya) — "handy man"; first true human; brain 650-800 cc; tool-maker (Olduvai Gorge); did not eat meat.',
        hindi: '**होमो हैबिलिस** (~2 माइया) - "काम में लाने वाला आदमी"; पहला सच्चा इंसान; मस्तिष्क 650-800 सीसी; उपकरण-निर्माता (ओल्डुवई गॉर्ज); मांस नहीं खाया.',
            },
            {
              english: '**Homo erectus** (~1.5 mya) — Java man, Peking man; brain ~900 cc; ate meat; used fire.',
        hindi: '**होमो इरेक्टस** (~1.5 माइआ) - जावा मानव, पेकिंग मानव; मस्तिष्क ~900 सीसी; मांस खाया; आग का इस्तेमाल किया.',
            },
            {
              english: '**Homo neanderthalensis** (Neanderthal, ~0.1-0.4 mya) — Europe & Near East; brain ~1400 cc; buried dead; used hides.',
        hindi: '**होमो निएंडरथेलेंसिस** (निएंडरथल, ~0.1-0.4 माइया) - यूरोप और निकट पूर्व; मस्तिष्क ~1400 सीसी; दफ़नाया हुआ मृत; प्रयुक्त खाल.',
            },
            {
              english: '**Homo sapiens** (~75,000-10,000 ya) — modern humans; arose in Africa, migrated; agriculture ~10,000 ya; civilisations ~5000 ya.',
        hindi: '**होमो सेपियन्स** (~75,000-10,000 या) - आधुनिक मानव; अफ़्रीका में पैदा हुए, प्रवासित हुए; कृषि ~10,000 या; सभ्यताएँ ~5000 या.',
            },
            {
              english: 'Trends: **bipedalism**, increase in brain size, reduction in jaw/face, opposable thumb, language.',
        hindi: 'रुझान: **द्विपादवाद**, मस्तिष्क के आकार में वृद्धि, jaw/face में कमी, विरोधी अंगूठा, भाषा।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{Big Bang} \\approx 13.7\\ \\text{bya; Earth} \\approx 4.5\\ \\text{bya}',
      desc: {
        english: '',
        hindi: 'बिग बैंग 13.7\\ बया; पृथ्वी 4.5\\ बया',
      },
    },
    {
      latex: 'p^2 + 2pq + q^2 = 1',
      desc: {
        english: 'Hardy-Weinberg',
        hindi: 'हार्डी-वेनबर्ग',
      },
    },
    {
      latex: '\\text{Homologous} \\Rightarrow \\text{divergent; Analogous} \\Rightarrow \\text{convergent}',
      desc: {
        english: '',
        hindi: 'सजातीय अपसारी; अनुरूप अभिसरण',
      },
    },
    {
      latex: '\\text{Miller-Urey: CH}_4 + NH_3 + H_2 + H_2O \\to \\text{amino acids}',
      desc: {
        english: '',
        hindi: 'मिलर-यूरे: सीएच 4 + एनएच 3 + एच 2 + एच 2ओ अमीनो एसिड',
      },
    },
    {
      latex: '\\text{Natural selection: variation} + \\text{differential reproduction}',
      desc: {
        english: '',
        hindi: 'प्राकृतिक चयन: भिन्नता + विभेदक प्रजनन',
      },
    },
    {
      latex: '\\text{Bottleneck \\& Founder effect: genetic drift}',
      desc: {
        english: '',
        hindi: 'बॉटलनेक \\& संस्थापक प्रभाव: आनुवंशिक बहाव',
      },
    },
    {
      latex: 'Homo\\ habilis \\to H.\\ erectus \\to H.\\ neanderthalensis \\to H.\\ sapiens',
      desc: {
        english: '',
        hindi: 'होमो\\ हैबिलिस एच.\\ इरेक्टस एच.\\ निएंडरथेलेंसिस एच.\\ सेपियन्स',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'NEET',
      tag: 'Hardy-Weinberg',
      problem: {
        english: 'In a population, frequency of allele a is 0.3. Frequency of heterozygotes Aa is:',
        hindi: 'एक जनसंख्या में एलील a की आवृत्ति 0.3 है। हेटेरोज़ायगोट्स एए की आवृत्ति है:',
      },
      answer: {
        english: '0.42 (= 2 × 0.7 × 0.3)',
        hindi: '0.42 (= 2 × 0.7 × 0.3)',
      },
      solution: {
        english: 'p = 0.7, q = 0.3; 2pq = 0.42.',
        hindi: 'पी = 0.7, क्यू = 0.3; 2pq = 0.42.',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Evidence',
      problem: {
        english: 'Wings of butterfly and birds are examples of:',
        hindi: 'तितली और पक्षियों के पंख इसके उदाहरण हैं:',
      },
      answer: {
        english: 'Analogous organs (convergent evolution)',
        hindi: 'अनुरूप अंग (अभिसरण विकास)',
      },
      solution: {
        english: 'Different origin, same function.',
        hindi: 'भिन्न मूल, समान कार्य।',
      },
    },
    {
      year: 2022,
      exam: 'NEET',
      tag: 'Origin',
      problem: {
        english: 'Miller-Urey experiment supported the theory of:',
        hindi: 'मिलर-उरे प्रयोग ने निम्नलिखित सिद्धांत का समर्थन किया:',
      },
      answer: {
        english: 'Chemical / abiogenic origin of life',
        hindi: 'जीवन की रासायनिक/जैविक उत्पत्ति',
      },
      solution: {
        english: 'Demonstrated formation of amino acids from inorganic precursors.',
        hindi: 'अकार्बनिक अग्रदूतों से अमीनो एसिड का निर्माण प्रदर्शित किया गया।',
      },
    },
    {
      year: 2021,
      exam: 'NEET',
      tag: 'Human evolution',
      problem: {
        english: 'First true human (manufactured tools but did not eat meat) was:',
        hindi: 'पहला सच्चा मानव (उपकरण निर्मित किया लेकिन मांस नहीं खाया) था:',
      },
      answer: {
        english: 'Homo habilis',
        hindi: 'होमो हैबिलिस',
      },
      solution: {
        english: 'Olduvai Gorge; brain 650-800 cc.',
        hindi: 'ओल्डुवई गॉर्ज; मस्तिष्क 650-800 सीसी.',
      },
    },
    {
      year: 2020,
      exam: 'NEET',
      tag: 'Lamarck',
      problem: {
        english: 'Inheritance of acquired characters was proposed by:',
        hindi: 'अर्जित लक्षणों का वंशानुक्रम किसके द्वारा प्रस्तावित किया गया था:',
      },
      answer: {
        english: 'Lamarck',
        hindi: 'लैमार्क',
      },
      solution: {
        english: 'Disproved by Weismann\'s mice tail experiment.',
        hindi: 'वीज़मैन के चूहों की पूंछ प्रयोग द्वारा अस्वीकृत।',
      },
    },
  ],
  next: {
    slug: 'digestion-absorption',
    title: 'Digestion and Absorption',
  },
};

export default chapter;
